import {
	Badge,
	Box,
	Center,
	Heading,
	HStack,
	SimpleGrid,
	Spacer,
	Text,
	VStack,
} from "@chakra-ui/react";
import { useWeb3React } from "@web3-react/core";
import Head from "next/head";
import React, { useEffect, useState } from "react";
import Shell from "../components/ui/layouts/Shell";
import { materialBalance, ownedRaiders } from "../util/web3/interactBank";
import { Raider } from "../types/raider";
import RaiderCardLayout from "../components/ui/layouts/RaiderCardLayout";
import { getEconomyTools } from "../util/web3/interactAlchemy";
import { CardWithAvatar } from "../components/ui/card/CardWithAvatar";

export interface EconomyTool {
	readonly id: number;
	readonly charges_left: number;
	readonly level: number;
	readonly profession: number;
	readonly xp: number;
	readonly professionId: number;
	readonly weekly_charges: number;
	readonly multiplier: number;
	readonly image:"https://storage.googleapis.com/crypto-raiders-assets/economy-tools/BASIC_ALCHEMY_TABLE.png"
}

export default function Home() {
	const [allRaiders, setAllRaiders] = useState<Raider[]>([]);
	const [toolTokens, setToolTokens] = useState<EconomyTool[]>([]);

	const [balances, setBalances] = useState<Record<string,number>>({});

	const { account } = useWeb3React();


	const [isLoading, setIsLoading] = useState(false);

	const updateMaterialBalances = () => {
		const balanceCalls = [materialBalance("GRIMWEED"), materialBalance("NEWT"), materialBalance("AURUM"),materialBalance("SPOREBARK"), materialBalance("MHP"), materialBalance("MDP")]

		Promise.all(balanceCalls).then(resp => {
			const newBalances = {

			} as Record<string,number>;
			newBalances[process.env.NEXT_PUBLIC_GRIMWEED as string] = resp[0]
			newBalances[process.env.NEXT_PUBLIC_NEWT as string] = resp[1]
			newBalances[process.env.NEXT_PUBLIC_AURUM as string] = resp[2]
			newBalances[process.env.NEXT_PUBLIC_SPOREBARK as string] = resp[3]

			newBalances[process.env.NEXT_PUBLIC_MINOR_HEALTH_POTION as string] = resp[4]
			newBalances[process.env.NEXT_PUBLIC_MINOR_DAMAGE_POTION as string] = resp[5]

			setBalances(newBalances)
		});

	}

	const updateTools = async () => {
		const tools = await getEconomyTools()
		setToolTokens(tools)
	}

	useEffect(() => {
		const fetchData = async () => {

			updateMaterialBalances();
			updateTools();

			setIsLoading(true);
			try {
				const tempRaiders: any = await ownedRaiders();
				if (tempRaiders) {
					setAllRaiders(tempRaiders);
				}
				setIsLoading(false);
			} catch (e) {
				setIsLoading(false);
			}
		};

		fetchData();
	}, [account]);

	return (
		<Shell>
			<Head>
				<title>Crypto Raiders - Alchemy</title>
			</Head>
			<Box as="section" pb="20">
				<Box bg="gray.700" pt="20" pb="20">
					<Box
						maxW={{ base: "xl", md: "7xl" }}
						mx="auto"
						px={{ base: "6", md: "8" }}
					>
						<Box mb="6" color="white" maxW="xl">
							<Heading
								size="2xl"
								letterSpacing="tight"
								fontWeight="extrabold"
								lineHeight="normal"
								fontFamily="Press Start 2P"
							>
								⚔️ Your Alchemists
							</Heading>
							<Text fontSize="lg" mt="0" fontWeight="medium" color="gray.200">
								You have{" "}
								{allRaiders === undefined ? "-" : allRaiders?.length}{" "}
								raiders available for Alchemy.
							</Text>
							<Text fontSize="lg" mt="0" fontWeight="medium" color="gray.200">
								You have {toolTokens.length } economy tool{toolTokens.length == 1 ? '' : 's'} to increase your yield.
							</Text>

							<Text fontSize="sm" mt="4" color="gray.400">
								These are your Raiders ready to brew some potions! Whichever Raider you brew with will earn Alchemy experience, and their Alchemy level will determine what potions they can brew in the future. 
							</Text>
						</Box>
					</Box>
				</Box>
				<Box mt="-20">
					<Box
						maxW={{ base: "xl", md: "7xl" }}
						mx="auto"
						px={{ base: "6", md: "8" }}
					>
						<Center hidden={!isLoading}>
							<div className="sk-folding-cube">
								<div className="sk-cube1 sk-cube"></div>
								<div className="sk-cube2 sk-cube"></div>
								<div className="sk-cube4 sk-cube"></div>
								<div className="sk-cube3 sk-cube"></div>
							</div>
						</Center>


						{toolTokens.length != 0 && 
						<SimpleGrid
						marginTop={150}
						marginBottom={50}
        columns={{ base: 1, md: 2, lg: 4 }}
        spacing="6"
        hidden={isLoading}
      >
        {toolTokens.map((tool) => (
          <CardWithAvatar
            key={"tool-" + tool.id}
            avatarProps={{ raider: {image: "https://storage.googleapis.com/crypto-raiders-assets/economy-tools/BASIC_ALCHEMY_TABLE.png"} as any }}
          >

<VStack spacing="4" flex="1" align="left" width="100%" marginTop="5">
			<VStack spacing="1" flex="1" align="left">
				<Text fontWeight="bold">Basic Alchemy Table</Text>
				<HStack mb={2}>
					<Badge variant="outline">lvl. {tool.level}</Badge>
					<Badge variant="outline">xp. {tool.xp}</Badge>
					<Badge variant="outline">Id: {tool.id}</Badge>
					<Spacer />
				</HStack>
			</VStack>
			<Text paddingBottom={0}>
			Profession: {[null,"Herbalism","Alchemy"][tool.professionId]}
				</Text>
			<Text paddingBottom={0}>
			Yield Multiplier: {tool.multiplier}%
				</Text>
				<Text paddingBottom={0}>
				Charges: { tool.charges_left}/{tool.weekly_charges}

					</Text>
		</VStack>
          </CardWithAvatar>
        ))}
      </SimpleGrid>
}

            <RaiderCardLayout 
				tools={toolTokens}
				updateTools={updateTools}
              isLoading={isLoading}
              raiders={allRaiders}
              balances={balances}
              button="alchemy"
            />
					</Box>
				</Box>
			</Box>
		</Shell>
	);
}
